import { ImageMeta } from 'nfty-common/lib/model/image-set';
import { CSSProperties } from 'react';

interface ZoomImageProps {
    image?: ImageMeta;
}

export const ZoomImage = ((props: ZoomImageProps) => {
    const { image } = props;

    const backgroundStyle: CSSProperties = {
        zIndex: 1,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        position: 'absolute',
        transform: 'translateZ(0px)',
        filter: 'blur(4px)'
    };

    if (image) {
        return (
            <div className="h-100 bg-darker d-flex justify-content-center align-items-center">
                <img style={{ zIndex: 50 }} className="mw-100 mh-100" src={image.data} alt="main artwork" />
                <img style={backgroundStyle} src={image.data} alt="main artwork" />
            </div>
        );
    } else {
        return (null);
    }
});